const PX_IN_REM = 0.0625;

export const pxToRem = (px: number) => `${px * PX_IN_REM}rem`;
